import { ChangeEvent, FC } from 'react';
import { Controller, FieldError, get, useFormContext } from 'react-hook-form';

import { Input, InputProps } from '../Input';
import { FormElementProps } from '../types';

export interface FormTextAreaFieldProps
  extends Omit<InputProps, 'name' | 'onChange'>,
    FormElementProps {
  handleChange?: (name: string, value: string | number) => void;
}

export const FormTextAreaField: FC<FormTextAreaFieldProps> = (props) => {
  const { name, rules, defaultValue, handleChange, rows, minRows, ...rest } =
    props;
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name) as FieldError;

  return (
    <Controller
      control={control}
      defaultValue={defaultValue || ''}
      name={name}
      render={({ field }: any) => (
        <Input
          {...rest}
          {...field}
          multiline
          rows={rows ?? 4}
          minRows={minRows}
          error={error?.message}
          name={name}
          onChange={(
            event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
          ) => {
            if (handleChange != null)
              handleChange(event.target.name, event.target.value);
            field.onChange(event);
          }}
        />
      )}
      rules={rules}
    />
  );
};
